var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('v-btn',{staticClass:"ma-2",attrs:{"outlined":"","large":"","color":"green","to":"/speisekarte"}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("mdi-arrow-left-circle")]),_vm._v("Back ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }